import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function Main() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Assuming these are the 3 banner images
  const slides = [
    "/main/main1-1.jpeg",
    "/main/main1-2.jpeg",
    "/main/main1-3.jpeg",
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        {/* Hero Carousel */}
        <section className="hero-carousel">
          <div className="carousel-container">
            <button className="nav-btn prev" onClick={prevSlide}>
              <FaChevronLeft />
            </button>

            <div className="slides-wrapper">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`slide ${index === currentSlide ? "active" : ""}`}
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  <img src={slide} alt={`Banner ${index + 1}`} />
                </div>
              ))}
            </div>

            <button className="nav-btn next" onClick={nextSlide}>
              <FaChevronRight />
            </button>
          </div>

          <div className="carousel-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
              ></span>
            ))}
          </div>
        </section>

        {/* Promotional Banners */}
        <section className="promo-banners">
          <div className="promo-container">
            <div className="promo-left">
              <div className="promo-card large">
                <div className="promo-content">
                  <h3 className="new-tag">NEW</h3>
                  <h2>Trail Buddy Plush</h2>
                  <p>A soft, playful companion for your dog's next adventure.</p>
                  <button className="shop-btn">SHOP NOW</button>
                </div>
                <img src="/main/main2-1.jpeg" alt="Trail buddy plush dog toy" />
              </div>
            </div>
            <div className="promo-right">
              <div className="promo-card small">
                <div className="promo-content">
                  <h3 className="off-tag">15% OFF</h3>
                  <h2>
                    Beef
                    <br />
                    Angus Strips & Stuffers
                  </h2>
                  <button className="shop-btn">SHOP NOW</button>
                </div>
                <img src="/main/main2-2.jpeg" alt="Beef strips and stuffers" />
              </div>
              <div className="promo-card small">
                <div className="promo-content">
                  <h3 className="new-tag">NEW</h3>
                  <h2>
                    Wholesome
                    <br />
                    Dry Dog Food
                  </h2>
                  <button className="shop-btn">SHOP NOW</button>
                </div>
                <img src="/main/main2-3.webp" alt="Wholesome dry dog food" />
              </div>
            </div>
          </div>
        </section>

        {/* Account Perks Banner */}
        <section className="account-perks">
          <div className="perks-container">
            <div className="perks-content">
              <h2>Creating an account has its perks.</h2>
              <p className="perks-subtitle">
                ENJOY EXCLUSIVE MEMBERS-ONLY BENEFITS LIKE:
              </p>
              <ul className="perks-list">
                <li>
                  <span className="check">✔</span> Order tracking, history, and
                  easy reordering
                </li>
                <li>
                  <span className="check">✔</span> Create a pet profile for your
                  pet for personalized product recommendations
                </li>
              </ul>
              <button className="create-account-btn">CREATE AN ACCOUNT</button>
            </div>
            <div className="perks-image">
              <img src="/main/main3.png" alt="Pets playing" />
            </div>
          </div>
        </section>

        {/* Blog Section */}
        <section className="blog-section">
          <h2>Blog</h2>
          <div className="blog-grid">
            <div className="blog-card">
              <img src="/main/main4-1.webp" alt="New Puppy" />
              <div className="blog-info">
                <span className="blog-date">Updated March 12th, 2026</span>
                <h3>New Puppy Checklist: Preparing for a New Puppy</h3>
                <p>
                  Got a new puppy? This New Puppy Checklist will help you get
                  ready with essential supplies, training tips, and safety
                  must-haves.
                </p>
                <Link to="/blog/puppy-checklist" className="read-more">
                  Read More
                </Link>
              </div>
            </div>
            <div className="blog-card">
              <img src="/main/main4-2.webp" alt="Wet Cat Food" />
              <div className="blog-info">
                <span className="blog-date">Published January 26th, 2026</span>
                <h3>Best Wet Cat Food for Hydration & Flavour</h3>
                <p>
                  Cats love wet food. So why not feed them the best wet cat food
                  in Canada? Check out our 10 best wet cat food brands of 2026
                  to enrich their diet.
                </p>
                <Link to="/blog/wet-cat-food" className="read-more">
                  Read More
                </Link>
              </div>
            </div>
            <div className="blog-card">
              <img src="/main/main4-3.webp" alt="Cat Grooming" />
              <div className="blog-info">
                <span className="blog-date">Updated March 15th, 2026</span>
                <h3>At-Home Cat Grooming Tips for Better Skin & Coat</h3>
                <p>
                  How often should you brush your cat? Can you give a cat a
                  bath? Learn easy cat grooming tips to make at-home cat
                  grooming a breeze.
                </p>
                <Link to="/blog/cat-grooming" className="read-more">
                  Read More
                </Link>
              </div>
            </div>
            <div className="blog-card">
              <img src="/main/main4-4.jpeg" alt="Dog Grooming" />
              <div className="blog-info">
                <span className="blog-date">Updated March 2nd, 2026</span>
                <h3>Ultimate DIY Dog Grooming Guide for Beginners</h3>
                <p>
                  DIY dog grooming is a great way to keep your dog looking
                  healthy and handsome. Learn how to brush, bathe, and trim your
                  dog at home.
                </p>
                <Link to="/blog/dog-grooming" className="read-more">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Product Slider Section */}
        <section className="product-slider-section">
          <h2>Get Ready For Adventure</h2>

          <div className="product-slider-container">
            <div className="product-grid">
              {productData.slice(0, 5).map((product) => (
                <Link
                  onClick={toTop}
                  to={`/shopDetails/${product.id}`}
                  key={product.id}
                  className="product-card"
                >
                  <div className="product-image-container">
                    {product.id === 4 && (
                      <span className="badge-made-in-canada">
                        Made in Canada
                      </span>
                    )}
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-details">
                    <h4 className="product-name">{product.name}</h4>
                    <p className="product-price">${product.price}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Recent Reviews Section */}
        <section className="recent-reviews-section">
          <div className="reviews-header">
            <h2>Recent Reviews</h2>
            <p className="subtitle">
              Check out these reviews from customers just like you...
            </p>
          </div>

          <div className="reviews-container">
            <h3 className="section-title">Real reviews from real customers</h3>
            <div className="overall-rating">
              <div className="stars">
                ★★★★<span className="half-star">★</span>
              </div>
              <span className="review-count">41485 reviews</span>
            </div>

            <div className="reviews-slider-wrapper">
              <div className="reviews-grid">
                {/* Review 1 */}
                <div className="review-card">
                  <div className="review-meta">
                    <span className="author">Eric G.</span>
                    <span className="date">04/26/26</span>
                  </div>
                  <div className="stars">★★★★★</div>
                  <h4 className="review-title">A new favourite</h4>
                  <p className="review-text">
                    My cat comes running at mealtime and finishes every serving.
                    The soft texture is easy to portion.
                  </p>
                  <div className="reviewed-product">
                    <img src="/img/products/product-05.webp" alt="Duck recipe wet cat food" />
                    <span className="product-name">
                      hetcratehub Wet Cat Food - Duck Recipe
                    </span>
                  </div>
                </div>

                {/* Review 2 */}
                <div className="review-card">
                  <div className="review-meta">
                    <span className="author">Kathryn P.</span>
                    <span className="date">04/27/26</span>
                  </div>
                  <div className="stars">★★★★★</div>
                  <h4 className="review-title">Great for a growing kitten</h4>
                  <p className="review-text">
                    The portion is convenient and the texture worked well while
                    our kitten was adjusting to solid food.
                  </p>
                  <div className="reviewed-product">
                    <img src="/img/products/product-10.webp" alt="Chicken recipe wet kitten food" />
                    <span className="product-name">hetcratehub Wet Kitten Food - Chicken Recipe</span>
                  </div>
                </div>

                {/* Review 3 */}
                <div className="review-card">
                  <div className="review-meta">
                    <span className="author">Sandie T.</span>
                    <span className="date">04/27/26</span>
                  </div>
                  <div className="stars">★★★★★</div>
                  <h4 className="review-title">Keeps my dog busy</h4>
                  <p className="review-text">
                    My dog gets excited as soon as the treat comes out. The
                    longer size gives her plenty of chewing time and is easy to
                    hold between her paws.
                    <span className="read-more-link">Read more</span>
                  </p>
                  <div className="reviewed-product">
                    <img src="/img/products/product-16.webp" alt="Twelve-inch beef chew strip" />
                    <span className="product-name">
                      hetcratehub Beef Chew Strip - 12 Inches
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Story Section */}
        <section className="our-story-section">
          <div className="story-container">
            <p>
              hetcratehub brings practical pet essentials together in one
              friendly place. We focus on clear product information, dependable
              everyday choices, and support that helps pet families shop with
              confidence. Our goal is simple: make it easier to find food,
              treats, and supplies that fit life with your companion.
            </p>
            <Link to="/about" className="story-btn" onClick={toTop}>
              OUR STORY
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
